import React, {PureComponent as Component} from 'react';

import Field from "../../../../ui/template/Form/Field";
import InputText from "../../../../ui/template/Input/InputText";
import Submit from "../../../../ui/template/Form/Submit";
import FormManager from "../../../../ui/template/Form/FormManager";
import Alerts from "../../../../ui/template/Alert/Alerts";
import DropZone from "../../../../ui/template/Drag/DropZone";
import {MCbrowser} from "../../../Context/browserContext";
import TextArea from "../../../../ui/template/Input/TextArea";
import memberFileUploadApi from "../../../Controllers/MemberFileUploadApi";
import moshkelatInsertApi from "./Api/insertApi";
import getOstanDataApi from "../../Project/Controllers/Api/GetOstanDataApi";
import getCityDataApi from "../../Project/Controllers/Api/GetCityDataApi";
import $ from "jquery";
import Interface from "../../../../ui/template/Interface";
import ModalTxt from "../../../Layout/ModalTxt";

function showTab($el){
    $($el).tab('show');
}


class  MoshkelatInsert extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.HtitleChange = this.titleChange.bind(this);
        this.HtellChange = this.tellChange.bind(this);
        this.HostanIdChange = this.ostanIdChange.bind(this);
        this.HshahrestanIdChange = this.shahrestanIdChange.bind(this);
        this.HaddressChange = this.addressChange.bind(this);
        this.HdescriptionChange = this.descriptionChange.bind(this);
        this.HrahkarChange = this.rahkarChange.bind(this);
         
        this.HuploadDelete = this.uploadDelete.bind(this);
        this.HpostUpload = this.postUpload.bind(this);
        this.HreceivedFile = this.receivedFile.bind(this);

        this.Htab2show = this.tab2show.bind(this);
        this.Htab3show = this.tab3show.bind(this);

        this.handlePostUp = this.postUp.bind(this);
        this.state = {render:true};
        this.values = {  title: '',tell: '',address:"",ostanId:'',shahrestanId:''  ,description:'',rahkar:""  };

        this.form1=React.createRef();
        this.formAlerts=React.createRef();
        this.props=props;

        this.receivedFiles=[];

        this.ostanOptions=[];
        this.shahrestanOptions=[];

        this.dropZone=React.createRef();

        this.ostan=React.createRef();
        this.shahrestan=React.createRef();

        this.modalTxt=React.createRef();
    };


    tab2show(e) {
        showTab('#profile-tab');
        return true;
    };

    tab3show(e) {
        showTab('#upload-tab');
        return true;
    };

    titleChange(e) {
        this.values.title=e.target.value;
        return true;
    };

    ostanIdChange(v) {
        this.values.ostanId =   v;
        this.getCityLoad(this.values.ostanId);
        return true;
    };

    shahrestanIdChange(v) {
        this.values.shahrestanId =   v;
        return true;
    };

    addressChange(e) {
        this.values.address =  e.target.value;
        return true;
    };

    tellChange(e) {
        this.values.tell =  e.target.value;
        return true;
    };   

    descriptionChange(e) {
        this.values.description =  e.target.value;
        return true;
    };

    rahkarChange(e) {
        this.values.rahkar =  e.target.value;
        return true;
    };

    uploadDelete(obj){
        if(obj.state!=="uploading") {
            this.dropZone.current.deleteItem(obj.id);
            let filtered = this.receivedFiles.filter(function(el) { return el.id != obj.id; });
            this.receivedFiles= filtered;
            this.receivedFileId=-1;
            this.uploadedFileId=-1;
        }
    };

    receivedFile(id){
        let obj = {};
        obj["id"] = id;
        obj["status"] = false;
        obj["uploadedId"] = 0;
        this.receivedFiles.push(obj);
    };

    async postUpload(fileData,fileId) {
        if(this.isAlive) {
            if (this.form1.current.isAlive) this.form1.current.setDisable();
            let pageAlerts = this.context.pageAlerts;
            this.dropZone.current.HchangeStateItem(fileId, "uploading");
            let res = await memberFileUploadApi(fileData, fileId, pageAlerts, this.dropZone.current.HuploadProgress);
            if(this.isAlive) {
                if (res.hasOwnProperty("id")) {
                    let id = res.id;
                    if (id > 0) {
                        this.uploadedFileId=id;
                        this.dropZone.current.HchangeStateItem(fileId,"uploaded",null,null);
                        await this.setUploadId(fileId,id);
                        await this.finishedUpload();
                    }
                }
                //if (this.form1.current.isAlive) this.form1.current.setEnable();
            }
        }
    }

    setUploadId(fileId,id){
        if(this.receivedFiles.length>0){
            for (let i = 0; i < this.receivedFiles.length; i++) {
                if(this.receivedFiles[i].id===fileId){
                    this.receivedFiles[i].uploadedId=id;
                    this.receivedFiles[i].status=true;
                }
            }
        }
    }

    getUnUplodedId() {
        let receivedId=-1;
        if(this.receivedFiles.length>0){
            for (let i = 0; i < this.receivedFiles.length; i++) {
                if(this.receivedFiles[i].status===false){
                    receivedId=this.receivedFiles[i].id;
                    break;
                }
            }
        }
        return  receivedId ;
    }

    getUploadedIdes() {
        let uploadedIdes=[];
        if(this.receivedFiles.length>0){
            for (let i = 0; i < this.receivedFiles.length; i++) {
                if(this.receivedFiles[i].status===true){
                    uploadedIdes.push(this.receivedFiles[i].uploadedId);
                }
            }
        }
        return uploadedIdes;
    }

    async finishedUpload(){
        let receivedId=await this.getUnUplodedId();
        if(receivedId>0){
            await this.dropZone.current.getFileData(this.HpostUpload, receivedId);
        }else{
            let uploadedIdes=await this.getUploadedIdes();
            await this.postingUp(uploadedIdes);
        }
    }

    async postUp() {
        await this.finishedUpload();
    }

    async postingUp(filesTmpId=[]) {
        let pageAlerts = this.context.page.pageAlerts;
        let l=await moshkelatInsertApi(this.values.title, this.values.ostanId,this.values.shahrestanId,
            this.values.tell,this.values.address,this.values.description,this.values.rahkar,filesTmpId ,pageAlerts,this.formAlerts);
        if(l!=="false") {
            if (Interface.isEmptyString(l)) {
            } else {
                let page = this.context.page;
                page.dispatcher.run("route", "moshkelat", "inserted");
                let txt = " کاربر گرامی اطلاعات مشکلات شما با موفقیت ثبت شد. کد پیگیری درخواست شما " +
                    "<span>" + l + "</span>"
                    + " می باشد ";
                this.modalTxt.current.setTxt(txt);
                this.modalTxt.current.show();
                this.reset();
            }
        }
    }

    refresh() {
        let r=!this.state.render;
        this.setState({render:r});
    }

    componentDidMount() {
        let $select2_1=$(this.ostan.current).select2({dir:"rtl",language:"fa" ,placeholder: "انتخاب استان"  });
        let $select2_2=$(this.shahrestan.current).select2({dir:"rtl",language:"fa" ,placeholder: "انتخاب شهر"  });
        $select2_1.data('select2').$container.addClass("form-control d-block w-100 line-h-2");
        $select2_2.data('select2').$container.addClass("form-control d-block w-100 line-h-2");
        let plugin=this;
        $(this.ostan.current).on('select2:select', function (e) {
            let data = e.params.data;
            if(data.selected){
                plugin.HostanIdChange(data.id);
            }
        });
        $(this.shahrestan.current).on('select2:select', function (e) {
            let data = e.params.data;
            if(data.selected){
                plugin.HshahrestanIdChange(data.id);
            }
        });
        this.getOstanLoad();
    }

    async getOstanLoad() {
        //this.ostan.current.setLoading();
        let pageAlerts = this.context.page.pageAlerts;
        let data = await getOstanDataApi(pageAlerts);
        if(this.isAlive) {
            if (data === false) {
                this.setState({isload: false, isClose: true});
            } else {
                if (data.hasOwnProperty("ostan")) {
                    let plugin=this;
                    this.ostanOptions = data.ostan.map((item, index) => (
                        <option key={plugin.ti++} value={item.id.toString()}  >{item.name}</option>
                    ));
                }
                await this.refresh();
                //this.ostan.current.closeLoading();
            }
        }
    }

    async getCityLoad(id) {
        //this.shahrestan.current.setLoading();
        let pageAlerts = this.context.page.pageAlerts;
        let data = await getCityDataApi(id,pageAlerts);
        if(this.isAlive) {
            if (data === false) {
                this.setState({isload: false, isClose: true});
            } else {
                let plugin=this;this.shahrestanOptions=[];
                if (data.hasOwnProperty("city")) {
                    this.shahrestanOptions = data.city.map((item, index) => (
                        <option key={plugin.ti++} value={item.id.toString()}  >{item.name}</option>
                    ));
                }
                this.shahrestanOptions.splice(0, 0, ( <option key={plugin.ti++}    > </option>));
                await this.refresh();
                let $select2_2=$(this.shahrestan.current).select2({dir:"rtl",language:"fa" ,placeholder: "انتخاب شهر" });
                $select2_2.data('select2').$container.addClass("form-control d-block w-100 line-h-2");
                $(this.shahrestan.current).val('').trigger('change');
                //this.shahrestan.current.closeLoading();
            }
        }
    }

    render() {

    return (
        <React.Fragment>
            <FormManager ref={this.form1} submit={this.handlePostUp}>
                <div className="js-validate"  >
                    <div className="border rounded bg-white mb-3">
                        <div className="box-title border-bottom p-3">
                            <h6 className="m-0">
                                ثبت
                                مشکلات مردمی
                            </h6>
                            <p className="mb-0 mt-0 small">
                                لطفا
                                اطلاعات خود را صحیح وارد نمائید. ممنون.
                            </p>
                        </div>
                    </div>
                    <div className="box shadow-sm border rounded bg-white mb-3 osahan-share-post">
                        <ul className="nav border-bottom osahan-line-tab" id="myTab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" id="profile-tab" data-toggle="tab" href="#pjrMoshInsertTab2"
                                   role="tab" aria-controls="profile" aria-selected="false">
                                    مشخصات مسائل
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="upload-tab" data-toggle="tab" href="#pjrMoshInsertTab3"
                                   role="tab" aria-controls="profile" aria-selected="false">
                                    بارگزای و آپلود مستندات
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content" id="pjrMoshInsertTabContent">
                            <div className="tab-pane fade show active  p-3  " id="pjrMoshInsertTab2" role="tabpanel"  >
                                <div className="row">
                                    <div className="col-12 col-sm-6 col-md-8 mb-4">
                                        <label className="form-label">
                                            عنوان مساله یا مشکل
                                            <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group">
                                            <Field   keyState="title">
                                                <InputText  className="form-control"   onChange={this.HtitleChange}   />
                                            </Field>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-4 mb-4">
                                        <div className="js-form-message">
                                            <label className="form-label">
                                                شماره تلفن
                                                <span className="text-danger">*</span>
                                            </label>
                                            <div className="form-group">
                                                <Field   keyState="tell">
                                                    <InputText  className="form-control"   onChange={this.HtellChange}   />
                                                </Field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-6 col-md-3 mb-4">
                                        <label className="form-label">
                                            استان
                                        </label>
                                        <div className="input-group">
                                            <Field   keyState="ostanId">
                                                <select  ref={this.ostan}      >
                                                    {this.ostanOptions}
                                                </select>
                                            </Field>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 mb-4">
                                        <label className="form-label">
                                            شهر
                                        </label>
                                        <div className="input-group">
                                            <Field   keyState="shahrestanId">
                                                <select  ref={this.shahrestan}         >
                                                    {this.shahrestanOptions}
                                                </select>
                                            </Field>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 mb-4">
                                        <label className="form-label">
                                            آدرس
                                        </label>
                                        <div className="input-group">
                                            <Field   keyState="address">
                                                <InputText  className="form-control"   onChange={this.HaddressChange}   />
                                            </Field>
                                        </div>
                                    </div>
                                </div>
                                <p>
                                    در اين بخش
                                    مسائل و مشکلات خود را کامل
                                    توضیح دهید </p>
                                <div className="row">
                                    <div className="col-12 mb-4">
                                        <label className="form-label">
                                            توصیف مسائل
                                        </label>
                                        <div className="input-group">
                                            <Field   keyState="description">
                                                <TextArea rows={6} className="form-control"  onChange={this.HdescriptionChange}  />
                                            </Field>
                                        </div>
                                    </div>
                                </div>
                                <p>

                                    در اين بخش
                                    راه کارها و پیشنهادات خود را با توجه به ظرفیت ها و پتانسیل های موجود بیان نمایید

                                </p>
                                <div className="row">
                                    <div className="col-12 mb-4">
                                        <label className="form-label">
                                            توصیف راه کارها
                                        </label>
                                        <div className="input-group">
                                            <Field   keyState="rahkar">
                                                <TextArea rows={6} className="form-control"  onChange={this.HrahkarChange}  />
                                            </Field>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3 text-right w-100">
                                    <button type="button" className="font-numberjob-bold btn btn-primary rounded p-2 float-left"
                                            onClick={this.Htab3show}  >  &nbsp;&nbsp;&nbsp;&nbsp;
                                        مرحله بعد
                                        &nbsp;&nbsp;&nbsp;&nbsp; </button>
                                </div>
                            </div>
                            <div className="tab-pane fade p-3  " id="pjrMoshInsertTab3" role="tabpanel" >
                                <DropZone openFileStr="بارگزاری تصاویر و فایل ها" ref={this.dropZone} deleteingItem={this.HuploadDelete}
                                          validTypes={["image/gif", "image/jpeg", "image/png", "image/bmp","image/x-icon","image/svg+xml",
                                              "application/x-rar-compressed", "application/octet-stream","application/zip", "application/octet-stream", "application/x-zip-compressed", "multipart/x-zip",
                                              "video/mp4","video/webm","video/ogg","audio/vnd.wave","audio/wave","audio/wav","audio/x-wav","audio/mp3",
                                              "application/pdf","application/octet-streamn","application/msword","application/vnd.ms-powerpoint"
                                          ]}
                                          receivedFile={this.HreceivedFile} isEdit={false} isBtnDirectory={false} isMultiple={true} maxFiles={20} />
                                <div className="mb-3 mt-3 text-right w-100">
                                    <button type="button" className="font-numberjob-bold btn btn-secondary rounded p-2 mr-3 float-left"
                                            onClick={this.Htab2show}  >  &nbsp;&nbsp;&nbsp;&nbsp;
                                        مرحله قبل
                                        &nbsp;&nbsp;&nbsp;&nbsp; </button>
                                    <Submit className="font-numberjob-bold btn btn-primary rounded p-2 float-left"  > &nbsp;&nbsp;&nbsp;&nbsp;
                                        ثبت درخواست
                                        &nbsp;&nbsp;&nbsp;&nbsp; </Submit>

                                </div>
                            </div>
                        </div>
                        <div className="row mt-2 mb-2 w-100">
                            <div className="col-12 col-sm-6 col-md-5 ">
                                <Alerts layout="relative" ref={this.formAlerts}/>
                            </div>
                        </div>
                    </div>
                </div>
            </FormManager>
            <ModalTxt ref={this.modalTxt} />
        </React.Fragment>
    )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

MoshkelatInsert.contextType = MCbrowser;

export default MoshkelatInsert;
